import { replaceWithHomeAwayCurrencySymbol, replaceWithHomeAwayFormatting } from './currencyInfo';
import { getCorrectedCurrencySymbol } from './currencyInfo';
import { CURRENCY_PRECISIONS } from './currencyInfo';
import { getCurrency } from 'locale-currency';
import i18nFormatter from './i18nFormatter';
var CurrencyFormatter = {
  /**
   * Formats the specified amount for the given locale and currency.
   * This logic was taken from https://github.homeawaycorp.com/hacommons/hacommons-i18n/blob/master/src/main/java/com/homeaway/commons/i18n/formatter/GlobalCurrencyFormatter.java#L239
   *
   * @param value the number value to format
   * @param currencyCode the currency code for the currency you wish to add (eg 'USD', 'AUD', 'GBP')
   * @param locale the locale to determine the format of the result (defaults to 'en_US')
   * @param maximumFractionDigits the maximum number of fraction digits to keep
   * @param minimumFractionDigits the minimum number of fraction digits to keep
   * @param useGrouping whether to use separator between thousands (default to true)
   * @returns The formatted amount with correct currency symbol based on the locale and currency
   */
  formatNumber: function formatNumber(_ref) {
    var value = _ref.value,
        currencyCode = _ref.currencyCode,
        _ref$locale = _ref.locale,
        locale = _ref$locale === void 0 ? 'en_US' : _ref$locale,
        maximumFractionDigits = _ref.maximumFractionDigits,
        minimumFractionDigits = _ref.minimumFractionDigits,
        _ref$useGrouping = _ref.useGrouping,
        useGrouping = _ref$useGrouping === void 0 ? true : _ref$useGrouping;
    var currency = currencyCode || getCurrency(locale);
    var options = {
      value: value,
      currency: currency,
      locale: locale,
      currencyDisplay: 'code',
      maximumFractionDigits: maximumFractionDigits,
      minimumFractionDigits: minimumFractionDigits,
      style: 'currency',
      useGrouping: useGrouping
    };

    try {
      var formattedNumber = i18nFormatter.formatNumber(options); // Override intl formatting

      formattedNumber = replaceWithHomeAwayFormatting(formattedNumber, currency, locale, value); // Override the currency symbol

      formattedNumber = replaceWithHomeAwayCurrencySymbol(formattedNumber, currency, locale);
      return formattedNumber;
    } catch (e) {
      return String(value);
    }
  },

  /**
   * Resolves currency symbol based on currency code and locale
   *
   * @param currencyCode the currency code for the currency you wish to add (eg 'USD', 'AUD', 'GBP')
   * @param locale the locale to determine the format of the result (defaults to 'en_US')
   * @returns string symbol based on ISO 4217 Currency Code.
   */
  symbol: function symbol(currencyCode, locale) {
    if (locale === void 0) {
      locale = 'en_US';
    }

    if (!currencyCode) {
      return '';
    }

    return getCorrectedCurrencySymbol(currencyCode, locale) || currencyCode;
  },

  /**
   * Returns currency precision based on ISO 4217.
   * @param currencyCode {String} three-letter currency code as found in keys of CURRENCY_CODES
   * @returns {Number} currency precision, default value is 2
   */
  precision: function precision(currencyCode) {
    return CURRENCY_PRECISIONS.hasOwnProperty(currencyCode) ? CURRENCY_PRECISIONS[currencyCode] : 2;
  }
};
export default CurrencyFormatter;
//# sourceMappingURL=currencyFormatter.js.map